export default __webpack_public_path__ + "static/tree-logo-9f663a4813afaeb38d3d315e6c8329cb.png";